<form #accountForm="ngForm" class="form-container">
    <div class="form-header">
        <div class="form-breadcrumb">
            <h3>Knock Off</h3>
        </div>
        <div class="form-actions">
            <button type="button" mat-flat-button color="primary" (click)="confirmDialog()">
                <mat-icon>check</mat-icon> Submit
            </button>
        </div>
    </div>
    <div class="form-card">
        <fieldset>
            <!-- Against Selection -->
            <div class="row">
                <div class="col-sm-12 mb-3">
                    <label class="form-section-label">Against <span class="span-class">*</span></label>
                    <mat-radio-group name="against" [(ngModel)]="selectedAgainstModel" required (change)="onAgainstModelChange()" class="d-flex gap-3 mt-2">
                        <mat-radio-button *ngFor="let item of againstMapping" [value]="item.value">
                            {{item.label}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>

            <!-- Select Object -->
            <div class="row">
                <div class="col-sm-4 mb-3">
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Select {{labels[selectedAgainstModel] || 'Object'}}</mat-label>
                        <mat-select #against_object_id (openedChange)="onAgainstObjectScroll($event)" [(value)]="selectedAgainstObject" (selectionChange)="onAgainstObjectChange()" required>
                            <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="onAgainstObjectKey($event)" matInput name="against_object">
                            <mat-option *ngFor="let against_object of allAgainstObjects" [value]="against_object.id">{{against_object.receipt_number || against_object.voucher_number }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-4 mb-3" *ngIf="againstObject">
                    <div class="balance-display">
                        <p *ngIf="againstObject.balance != undefined"><strong>Balance:</strong> {{againstObject.balance}}</p>
                        <p *ngIf="againstObject.credit_balance != undefined"><strong>Credit Balance:</strong> {{againstObject.credit_balance}}</p>
                        <p *ngIf="againstObject.debit_balance != undefined"><strong>Debit Balance:</strong> {{againstObject.debit_balance}}</p>
                    </div>
                </div>
            </div>

            <!-- Knock-Off Table -->
            <mat-tab-group animationDuration="0ms" class="mt-4">
                <mat-tab label="Knock-Off">
                    <div class="table-container mt-3">
                        <table mat-table [dataSource]="knockoffsDataSource" #knock_off_lines class="mat-elevation-z1">
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef>Select</th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="toggleSelection(row)" [checked]="selection.isSelected(row)" [disabled]="(againstObject && againstObject.balance <= 0 && !selection.isSelected(row))">
                                    </mat-checkbox>
                                </td>
                            </ng-container>

                            <ng-container class="mat-table-row" [matColumnDef]="column" *ngFor="let column of displayColumns; let i = index;">
                                <th class="font-weight-bold" mat-header-cell *matHeaderCellDef> {{displayHeaders[i]}} </th>
                                <td mat-cell *matCellDef="let obj" class="header-cell"> {{obj[column]}} </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayColumnsWithSelect"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayColumnsWithSelect;"></tr>
                        </table>
                    </div>
                </mat-tab>
            </mat-tab-group>

        </fieldset>
    </div>
</form>